import React, { useState } from "react";

const ContantUs = () => {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const validate = () => {
        let temp = {};

        if (!formData.name.trim()) {
            temp.name = "Name is required";
        }

        if (
            !formData.email ||
            !/\S+@\S+\.\S+/.test(formData.email)
        ) {
            temp.email = "Valid email required";
        }

        if (!formData.subject.trim()) {
            temp.subject = "Subject is required";
        }

        if (!formData.message.trim()) {
            temp.message = "Message is required";
        }

        return temp;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setSuccess("");
            return;
        }

        console.log(formData);

        setSuccess("Message sent successfully!");

        setTimeout(() => {
            setSuccess("");
        }, 3000);

        localStorage.setItem(
            "contactMessage",
            JSON.stringify(formData)
        );

        setFormData({
            name: "",
            email: "",
            subject: "",
            message: ""
        });

        setErrors({});
    };

    return (
        <React.Fragment>
            <section id="contact" class="contact section">

                <div class="container section-title" data-aos="fade-up">
                    <h2>Contact</h2>
                    <p><span>Need Help?</span> <span class="description-title">Contact Us</span></p>
                </div>

                <div class="container" data-aos="fade-up" data-aos-delay="100">

                    <div class="mb-5">
                        <iframe style={{ width: "100%", height: "400px" }}
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12097.433213460943!2d-74.0062269!3d40.7101282!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb89d1fe6bc499443!2sDowntown+Conference+Center!5e0!3m2!1smk!2sbg!4v1539943755621"
                            frameborder="0" allowfullscreen=""></iframe>
                    </div>

                    <div class="row gy-4">

                        <div class="col-md-6">
                            <div class="info-item d-flex align-items-center" data-aos="fade-up" data-aos-delay="200">
                                <i class="icon bi bi-geo-alt flex-shrink-0"></i>
                                <div>
                                    <h3>Address</h3>
                                    <p>A108 Adam Street, New York, NY 535022</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="info-item d-flex align-items-center" data-aos="fade-up" data-aos-delay="300">
                                <i class="icon bi bi-telephone flex-shrink-0"></i>
                                <div>
                                    <h3>Call Us</h3>
                                    <p>+1 5589 55488 55</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="info-item d-flex align-items-center" data-aos="fade-up" data-aos-delay="400">
                                <i class="icon bi bi-envelope flex-shrink-0"></i>
                                <div>
                                    <h3>Email Us</h3>
                                    <p>info@example.com</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="info-item d-flex align-items-center" data-aos="fade-up" data-aos-delay="500">
                                <i class="icon bi bi-clock flex-shrink-0"></i>
                                <div>
                                    <h3>Opening Hours<br /></h3>
                                    <p><strong>Mon-Sat:</strong> 11AM - 23PM; <strong>Sunday:</strong> Closed</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <form onSubmit={handleSubmit} method="post" class="php-email-form" data-aos="fade-up" data-aos-delay="600">

                        <div class="row gy-4">

                            <div class="col-md-6">

                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    class="form-control"
                                    placeholder="Your Name"
                                    required=""
                                />
                            </div>
                            {errors.name && (
                                <small className="text-danger">
                                    {errors.name}
                                </small>
                            )}

                            <div class="col-md-6 ">
                                <input
                                    type="email"
                                    class="form-control"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Your Email"
                                    required=""
                                />
                            </div>
                            {errors.email && (
                                <small className="text-danger">
                                    {errors.email}
                                </small>
                            )}

                            <div class="col-md-12">

                                <input
                                    type="text"
                                    class="form-control"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    placeholder="Subject"
                                    required=""
                                />
                            </div>
                            {errors.subject && (
                                <small className="text-danger">
                                    {errors.subject}
                                </small>
                            )}

                            <div class="col-md-12">

                                <textarea
                                    class="form-control"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="6"
                                    placeholder="Message"
                                    required=""
                                >

                                </textarea>
                            </div>
                            {errors.message && (
                                <small className="text-danger">
                                    {errors.message}
                                </small>
                            )}

                            <div class="col-md-12 text-center">

                                {success && (
                                    <div className="alert alert-success">
                                        {success}
                                    </div>
                                )}

                                <button type="submit">Send Message</button>
                            </div>

                        </div>
                    </form>

                </div>

            </section>
        </React.Fragment>
    )
}

export default ContantUs;